import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  card: {
    width: '100%',
    marginBottom: theme.spacing(3),
    backgroundColor: theme.palette.background.default,
    border: 'none',
    boxShadow: 'none',
    borderRadius: '30px',
    '& .MuiCardActionArea-root': {
      height: '100%'
    },
    '&:active': {
      backgroundColor: 'rgba(0,0,0,0.05)'
    },
    '&:hover .MuiCardContent-root .MuiCardHeader-root': {
      color: theme.palette.grey[500]
    }
  },
  cardActionAreaMoreRecent: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),
    justifyContent: 'space-between',
    padding: '10px',
    '&:hover': {
      borderRadius: '30px',
      backgroundColor: 'transparent'
    },
    '&:hover .MuiCardActionArea-focusHighlight': {
      opacity: 0
    },
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(1),
      flexDirection: 'column'
    }
  },
  moreRecentImg: {
    width: '50%',
    aspectRatio: '16/9',
    borderRadius: '20px',
    objectFit: 'cover',
    cursor: 'pointer',
    objectPosition: 'center center',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  moreRecentInformationContainer: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '&.MuiCardContent-root': {
      padding: 0
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  moreRecentTitle: {
    ...theme.typography.h4,
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary,
    display: '-webkit-box',
    lineHeight: '1.2em',
    boxOrient: 'vertical',
    lineClamp: 2,
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxLines: 2,
    width: '100%',
    textAlign: 'left',
    '&.MuiCardHeader-root': {
      padding: 0
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0
    }
  },
  moreRecentText: {
    display: '-webkit-box',
    lineHeight: '1.2em',
    minHeight: '4.4em',
    boxOrient: 'vertical',
    lineClamp: 4,
    WebkitLineClamp: 4,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxLines: 4,
    marginBottom: theme.spacing(2)
  },
  actionReadMore: {
    alignSelf: 'flex-end',
    cursor: 'pointer',
    color: theme.palette.primary.dark
  },
  actions: {
    alignSelf: 'flex-end',
    '& .MuiButton-root': {
      borderRadius: theme.spacing(2)
    },
    '& .MuiButtonBase-root .MuiButton-label .MuiTypography-body2': {
      fontSize: '1rem'
    },
    '&:hover': {
      color: theme.palette.background.paper
    },
    '&:active': {
      backgroundColor: 'transparent'
    }
  },
  actionsButton: {
    padding: '6px 10px',
    backgroundColor: 'none',
    color: theme.palette.primary.dark,
    '&:hover': {
      textDecoration: 'underline',
      backgroundColor: 'transparent'
    },
    '&:active': {
      backgroundColor: 'transparent'
    }
  }
}))
